import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
  const { user, loading, login } = useAuth();

  useEffect(() => {
    if (!loading && !user) login(window.location.pathname + window.location.search);
  }, [loading, user, login]);

  if (loading || !user) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-emerald-400" />
      </div>
    );
  }
  return children;
};
